import {APICore} from "./apiCore";
import {AUTH_LIMIT} from "./authLimit";

// Sign-in steps reject with an AuthLimitError when rate limited (see authLimit.ts).
const limited = { [AUTH_LIMIT]: true };

const api = new APICore();

// account
function login(params: { email: string; password: string }) {
    const baseUrl = "/agent-api/auth/login";
    return api.create(`${baseUrl}`, params, limited);
}

function refreshToken(params: { refresh_token: string }) {
    const baseUrl = "/agent-api/auth/refresh-token";
    return api.create(`${baseUrl}`, params);
}

function logout() {
    const baseUrl = "/agent-api/auth/logout";
    return api.create(`${baseUrl}`, {});
}

function forgotPassword(params: { email: string }) {
    const baseUrl = "/agent-api/auth/forgot_password/";
    return api.create(`${baseUrl}`, params);
}

function resetPassword(params: { token: string, password: string, password_confirmation: string }) {
    const baseUrl = "/agent-api/auth/reset-password/verify";
    return api.create(`${baseUrl}`, params);
}

function mfaVerify(params: { challengeToken: string; code: string }) {
    return api.create("/agent-api/auth/mfa/verify", params, limited);
}
function mfaResend(params: { challengeToken: string }) {
    return api.create("/agent-api/auth/mfa/resend", params, limited);
}
function mfaStatus() {
    return api.get("/agent-api/auth/mfa/status", {});
}
function mfaEnrollStart(params?: { code?: string }) {
    return api.create("/agent-api/auth/mfa/enroll/start", params || {});
}
function mfaEnrollConfirm(params: { challengeToken: string; code: string }) {
    return api.create("/agent-api/auth/mfa/enroll/confirm", params);
}
function mfaDisable(params: { code: string }) {
    return api.create("/agent-api/auth/mfa/disable", params);
}
function mfaRegenerateBackupCodes(params: { code: string }) {
    return api.create("/agent-api/auth/mfa/backup-codes/regenerate", params);
}

export {login, refreshToken, logout, forgotPassword, resetPassword,
    mfaVerify, mfaResend, mfaStatus, mfaEnrollStart, mfaEnrollConfirm, mfaDisable, mfaRegenerateBackupCodes};
